import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TemplateDeployment } from "types/generated";

import { TEMPLATE_DEPLOYMENT_TYPE_LABEL } from "../../constants";

const TemplateDeploymentsDeploymentTypeCell = ({
  item: deployment,
  ...cellProps
}: TableSimpleCellProps<TemplateDeployment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{TEMPLATE_DEPLOYMENT_TYPE_LABEL[deployment.deploymentType]}</TableCellText>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentsDeploymentTypeCell;
